import CartaoCredito from './cartao-credito';

export class CheckoutConfig {
  codigo: number;
  valorTotal: any; // TODO: qual é esse tipo??
  qtdCartoes: number;
  qtdParcelas: number;
  servico: {
    codigo: number
    descricao: string,
  };
  sistema: number;
  cartao: any; // TODO: qual é esse tipo??

  constructor(args) {
    Object.assign(this, args);
  }
}

export class Checkout {
  dadosPessoais: {
    cpd: number,
    cpf: string,
    numInscricao: string,
    nome: string,
    anoSem: string,
  };
  sistema: {
    codigoSistema: number,
    nomeSistema: string,
    servico: {
      codigo: number,
      descricao: string,
      valorTotal: number,
    },
  };
  cartao: CartaoCredito[];
  perfil: {
    codigo: number,
  };
  parcelas: {
    anoBol: number,
    sequencial: string,
    valorParcela: number,
    desconto: number,
    valorMulta: number,
    obsQuitacao: string,
    situacaoBoleto: null,
    numeroParcela: number,
    numeroTotalParcelas: number,
  };
  token: string;

  constructor(args) {
    Object.assign(this, args);
  }
}
